module.exports = __webpack_public_path__ + "img/L2_open.a699cb21.svg";